"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSliderScrollXBy = exports.getSliderWidth = exports.getSlider = void 0;
exports.getSlider = function () {
    if (typeof (window) === 'undefined')
        return;
    return document.getElementById('detail-slider');
};
exports.getSliderWidth = function (slider) {
    if (typeof (window) === 'undefined')
        return;
    return slider.getBoundingClientRect().width;
};
exports.setSliderScrollXBy = function (slider, deltaX) {
    if (typeof (window) === 'undefined')
        return;
    return slider.scrollBy({ left: deltaX, top: 0, behavior: 'smooth' });
};
